import { cn } from "@workspace/frontend-ui";

type Props = {
  totalGamesCount?: number;
  likes?: number;
  translations: Record<string, string>;
  align?: "start" | "center";
};

const HeroStats: FC<Props> = ({
  totalGamesCount,
  likes,
  translations,
  align = "start",
}) => {
  const hasLikes = !!likes;

  if (totalGamesCount === undefined && !hasLikes) {
    return null;
  }

  const itemClassName = cn(
    "flex flex-col",
    align === "center" && "items-center",
  );
  const labelClassName =
    "font-bold text-[10px]/[14px] text-muted-foreground uppercase";

  return (
    <dl className="flex items-center gap-6">
      {totalGamesCount !== undefined && (
        <div className={itemClassName}>
          <dd className="font-bold text-lg/7 text-white">{totalGamesCount}+</dd>
          <dt className={labelClassName}>
            {translations["widget.highlighted-games.games"]}
          </dt>
        </div>
      )}
      {hasLikes && (
        <div className={itemClassName}>
          <dd className="font-bold text-warning text-lg/7">{likes}</dd>
          <dt className={labelClassName}>
            {translations["widget.highlighted-games.likes"]}
          </dt>
        </div>
      )}
    </dl>
  );
};

export default HeroStats;
